<template>
  <v-container
    fill-height
    justify-content-start
    :class="{ 'section-width': lgAndUp }"
    class="pa-0"
  >
    <v-layout v-if="activities.extendedActivity" column>
      <div class="activity-header pb-10">
        <div class="activity-title" :class="{ 'pl-0': xsOnly }">
          <v-icon @click="$router.go(-1)" color="white" class="ms-3 me-3">mdi-arrow-left</v-icon>
          <v-toolbar-title>{{ activities.extendedActivity.activity.name }}</v-toolbar-title>
        </div>
        <v-img :set="url = activities.extendedActivity.activity.coverImageUrl" :lazy-src="url" :src="url" />
      </div>
      <reservation-type-chip :reservationMethod="reservationMethod" />
      <v-layout>
        <v-flex xs12 md7 class="app-scroll-section">
          <v-layout v-if="catalog" column class="pa-2 full-height">
            <div v-if="categories.length" class="ml-3 pt-3 primary--text" :class="{ 'title': smAndUp }">{{$t('reservations.categories')}}</div>
            <div
              v-for="(category, index) in categories"
              :key="'a' + index"
              @click="!state.loading ? openCategorySelection(category.category) : ''"
              :class="!state.loading ? 'clickable' : null"
            >
              <category-list-item :category="category" />
            </div>
            <div v-if="filterProducts.length" class="ml-3 pt-3 primary--text" :class="{ 'title': smAndUp }">{{$t('reservations.products')}}</div>
            <div
              v-for="(product, index) in filterProducts"
              :key="'b' + index"
              @click="!state.loading && !product.product.outOfStock ? openProductSelection(product.product) : ''"
              :class="!state.loading && !product.product.outOfStock ? 'clickable' : ''"
            >
              <product-list-item :product="product" />
            </div>
            <v-spacer/>
            <div class="pa-3" v-if="smAndDown">
              <summary-button-wrapper :goToRoute="routeNames.reservationSummary.name" />
            </div>
          </v-layout>
          <v-layout v-else justify-center align-center class="full-height">
            <v-progress-circular indeterminate />
          </v-layout>
        </v-flex>
        <v-divider v-if="mdAndUp" vertical />
        <v-flex
          v-if="mdAndUp"
          md5 class="full-height py-4">
          <summary-data/>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout v-else justify-center align-center>
      <v-progress-circular indeterminate />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

import workingHoursMixins from '@/mixins/WorkingHours'
import reservationMixins from '@/mixins/Reservation'
import vuetifyMixins from '@/mixins/Vuetify'

import routeNames from '@/router/routes'
import router from '@/router'
import store from '@/store'

export default {
  beforeRouteEnter (to, from, next) {
    if (store.getters['activityReservations/isUnsaved'] && localStorage.getItem('reservationMethodType')) {
      next()
    } else {
      router.go(-1)
    }
  },
  data () {
    return {
      moment,
      routeNames,
    }
  },
  methods: {
    openProductSelection (product) {
      this.$router.push({
        name: routeNames.catalogProductSelection.name,
        params: { productId: product.id },
      })
      this.$store.commit('cart/setSelectedProduct', product)
    },
    openCategorySelection (category) {
      this.$router.push({
        name: routeNames.catalogCategorySelection.name,
        params: { catalogCategoryId: category.id },
      })
    },
  },
  created () {
    this.$store.dispatch('activities/getCatalog', {
      id: this.$route.params.activityId,
    })
    this.$store.commit('activityReservations/setField', {
      field: 'activityId',
      value: this.$route.params.activityId,
    })
    this.$store.dispatch('activities/getActivity', {
      id: this.$route.params.activityId,
    })
  },
  computed: {
    ...mapGetters({
      reservationMethod: 'activityReservations/reservationMethod',
    }),
    ...mapState({
      activities: (state) => state.activities,
      catalog: (state) => state.activities.catalog,
      state: (state) => state.state,
      cartProducts: (state) => state.cart.cartProducts,
      activityReservations: (state) => state.activityReservations,
    }),
    filterProducts () {
      return this.catalog.products.filter(extProduct => {
        return extProduct.product.active && extProduct.product.pricingGroupsWithPrices.length
      })
    },
    categories () {
      return this.catalog.categories.filter(extCategory => {
        return extCategory.category.active && extCategory.products.some(extProduct => {
          return extProduct.product.active && extProduct.product.pricingGroupsWithPrices.length
        })
      })
    },
  },
  components: {
    CategoryListItem: () => import('@/components/view-components/catalog/CategoryListItem.vue'),
    ProductListItem: () => import('@/components/view-components/catalog/ProductListItem.vue'),
    SummaryButtonWrapper: () => import('@/components/view-components/catalog/SummaryButtonWrapper.vue'),
    ReservationTypeChip: () => import('@/components/view-components/reservations/ReservationTypeChip.vue'),
    SummaryData: () => import('@/components/view-components/catalog/SummaryData.vue'),
  },
  mixins: [
    workingHoursMixins,
    reservationMixins,
    vuetifyMixins,
  ],
}
</script>

<style lang="scss" scoped>
.notranslate {
  transform: none !important;
}
.section-width {
  max-width: 800px !important;
}
.activity-header {
  max-width: 100%;
  min-height: 90px;
  max-height: 90px;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  & .activity-title {
    position: absolute;
    z-index: 1;
    top: 8px;
  }
}
</style>
